import { makeStyles } from '@material-ui/core/styles'
import CloseButton from 'src/assets/InsuranceSpotlightImages/Common/cancel.svg'

const VideoPlayer = ({ data, closeVideoPlayer }) => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.videoContainer}>
        <div className={classes.headerContainer}>
          <div className={classes.videoTitle}>{data.title}</div>
          <div className={classes.closeButton} id='closeButton'>
            <img src={CloseButton} alt='close' onClick={closeVideoPlayer} />
          </div>
        </div>
        <iframe
          src={`${data.link}?autoplay=1`}
          className={classes.playerContainer}
          allow='autoplay'
          title='Video'
        />
      </div>
    </>
  )
}

export default VideoPlayer

export const useStyles = makeStyles({
  playerContainer: {
    width: '100%',
    height: '100%',
    border: 0,
  },
  videoTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '10px',
  },
  videoContainer: {
    backgroundColor: 'white',
    width: '100%',
    height: '100%',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    backgroundColor: 'white',
    borderBottom: '1px solid rgba(0,0,0,.125)',
  },
  closeButton: {
    margin: '10px',
    padding: '5px 10px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderRadius: '100%',
    },
  },
  // hover
})
